/**
 * A startup's activity tab.
 *
 * Fetches on its own rather than with the startup: most visits to a detail page
 * never open this tab, and a timeline is a second query the overview does not
 * need.
 *
 * @see docs/plan/IMPLEMENTATION_PLAN.md task 6.8
 */
import { useActivities } from '../../../lib/activities.queries';

import { ActivityTimeline } from './ActivityTimeline';

export interface ActivityTabProps {
  startupId: string;
}

export function ActivityTab({ startupId }: ActivityTabProps): React.JSX.Element {
  const { data, isPending, isError } = useActivities({
    startupId,
    page: 1,
    /* A generous page: a startup's whole history is usually shorter than this,
       and paging a timeline hides the older context the log exists to keep. */
    pageSize: 100,
  });

  return (
    <ActivityTimeline
      owner={{ startupId }}
      activities={data?.data ?? []}
      isPending={isPending}
      isError={isError}
    />
  );
}
